import React, { useEffect, useState } from "react";
import { fetchAlbums, fetchRoadhouse } from "@/api/client";
import { usePageContent } from "@/hooks/usePageContent";
import {
  ThresholdHero,
  ThresholdBio,
  PortalsSection,
  AlbumsStrip,
  RoadhouseStrip,
  NewHereGuide,
} from "./HomePageSections";

export default function HomePage() {
  const [latest, setLatest] = useState([]);
  const [albums, setAlbums] = useState([]);
  const t = usePageContent("home");

  // Imports `fetchAlbums` and `fetchRoadhouse` are stable module references,
  // so this effectively runs once on mount.
  useEffect(() => {
    let cancelled = false;
    fetchAlbums()
      .then((d) => { if (!cancelled) setAlbums((d || []).slice(0, 4)); })
      .catch(() => {});
    fetchRoadhouse()
      .then((d) => { if (!cancelled) setLatest((d || []).slice(0, 3)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="relative">
      <ThresholdHero t={t} />
      <ThresholdBio t={t} />
      <PortalsSection t={t} />
      <AlbumsStrip albums={albums} t={t} />
      <RoadhouseStrip posts={latest} t={t} />
      <NewHereGuide t={t} />
    </div>
  );
}
